module.exports = __webpack_public_path__ + "img/CompScope_Mag_3_Focus_2.634b5ae3.png";